import { render, staticRenderFns } from "./TelegramPage.vue?vue&type=template&id=3f0e0388&scoped=true&lang=pug&"
import script from "./TelegramPage.vue?vue&type=script&lang=js&"
export * from "./TelegramPage.vue?vue&type=script&lang=js&"
import style0 from "./TelegramPage.vue?vue&type=style&index=0&id=3f0e0388&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0e0388",
  null
  
)

export default component.exports